module.exports = __webpack_public_path__ + "static/media/719406c0.jpg";